module.exports = __webpack_public_path__ + "img/15-1.a62876a9.png";